
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { Company, User } from "@/interface";

  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

  @Component({
    components: {
      LoadingOverlay,
    },
  })
  export default class PropsGuard extends Vue {
    @Prop({ type: Object, default: null }) readonly currentUser!: User | null;
    @Prop({ type: Object, default: null }) readonly company!: Company | null;
    @Prop({ type: Boolean, required: true }) readonly authenticated!: boolean;


    get isContractorRole(): boolean {
      return this.currentUser?.role === "CONTRACTOR";
    }

    get dataLoaded(): boolean {
      return this.isContractorRole || this.company !== null;
    }
  }
